export default __webpack_public_path__ + "static/reactpainel2021-acedc0f308cb180bab502cddaa7e8686.png";